(() => {
  const root = document.documentElement;
  const protection = root.dataset.mpContentProtection;

  if (!protection || protection === 'false') return;

  const protectImages = root.dataset.mpProtectImages === 'true';
  const blockContextMenu = root.dataset.mpBlockContextMenu === 'true';
  const blockSourceShortcuts = root.dataset.mpBlockSourceShortcuts === 'true';
  const mediaSelector = 'img, picture, video, canvas, svg, [data-mp-protected-media]';

  if (protectImages) {
    document.addEventListener(
      'dragstart',
      (event) => {
        if (event.target instanceof Element && event.target.closest(mediaSelector)) {
          event.preventDefault();
        }
      },
      true
    );
  }

  if (blockContextMenu) {
    document.addEventListener('contextmenu', (event) => event.preventDefault(), true);
  }

  document.addEventListener('copy', (event) => event.preventDefault(), true);
  document.addEventListener('cut', (event) => event.preventDefault(), true);
  document.addEventListener('selectstart', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('input, textarea, select')) {
      event.preventDefault();
    }
  }, true);

  if (blockSourceShortcuts) {
    document.addEventListener(
      'keydown',
      (event) => {
        const key = event.key.toLowerCase();
        const blocksViewSource = (event.metaKey || event.ctrlKey) && key === 'u';
        const blocksDevTools =
          event.key === 'F12' ||
          ((event.metaKey || event.ctrlKey) && event.altKey && ['i', 'j', 'c'].includes(key)) ||
          (event.ctrlKey && event.shiftKey && ['i', 'j', 'c'].includes(key));

        if (blocksViewSource || blocksDevTools) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  }
})();
